import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Card } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Image } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { makeStyles } from '@material-ui/core/styles';
import '../../Americo/Americo.scss'

const useStyles = makeStyles((theme) => ({
	header: {
		color: `${theme.palette.primary.main} !important`,
	},
}));

export default function AmericoQuoteCard(props) {
	const classes = useStyles();
	return (
		<Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="lg">
			<Modal.Body className="show-grid">
				<Container>
					<Row className="float-right">
						<IconButton className='p-0' aria-label="close" onClick={props.onHide}>
							<CloseIcon />
						</IconButton>
					</Row>
					<Row>
						<Image className='image-property' src={process.env.PUBLIC_URL + '/americo/Americo.png'} alt={'Americo Logo'} />
					</Row>
					<Row className={`rating ${classes.header}`}>
						A++ Rating
            </Row>
					<Row className='productName'>
						Americo LoanMatch Protector
            </Row>
					<Row className='veribage-text'>
						As low as
            </Row>
					<Row>
						<Col xs="3" md="9">
							<Stats
								monthlyRate={props.monthlyRate}
							/>
						</Col>
						<Col xs="6" md="3" className={`${props.hideSelect ?"d-none":""}`}>
							<Button className="w-100 apply" color="primary" variant="contained" onClick={(e) => (props.onNext(e, props.monthlyRate))}>
								Continue
                </Button>
						</Col>
					</Row>
					<Row>
						<Col className="product-details-info pl-0 pb-20">
							Americo’s LoanMatch Protector helps protect your clients’ assets whether it is for a Small Business loan to safeguard the economic future of the company or a Mortgage Loan to make sure their mortgage is paid in the event of their death.
            </Col>
						<Col className='product-information'>
							Product Information
                <div className='product-information-elements'>
								<ul>
									<li>Ages 18 to 64</li>
									<li>Face Amounts from $10,000 to $1,000,000</li>
						            <li>Term periods include 5, 7, 10, 15, 20, 25, and 30 years</li>
									<li>Fixed level premiums</li>
								</ul>
							</div>
						</Col>
					</Row>
					<Row className='insurance-carrier-text'>
						Insurance Company Ratings
					</Row>
					<Row>
						<ProductDetailsRatingCard logo="/logos/ratings/ambest.jpg" rater="AM Best" ratingAMBest='A rating' />
					</Row>
				</Container>
			</Modal.Body>
		</Modal>
	);
}
const ProductDetailsRatingCard = (props) => {
	const classes = useStyles();
	return (
		<Card className="rating-card">
			<div className="rating-card-head">
				<img src={props.logo} alt={props.rater} className="img-fluid" />
			</div>
			<p className="rater mb-0">{props.rater}</p>
			<p className={`rating ${classes.header}`}>{props.ratingAMBest}</p>
		</Card>
	);
};
const Stats = (props) => {
	const classes = useStyles();
	return (
		<div className="product-details-stats">
			<Row>
				<Col className="pl-0">
					<p>
						<NumberFormat
							className="quote-amount-dollars"
							value={props.monthlyRate}
							displayType={'text'}
							thousandSeparator={true}
							decimalScale={2}
							fixedDecimalScale={true}
						/>
						<span className="quote-amount-mo">{props.monthlyRates} /mo</span>
					</p>
				</Col>

				<Col>
					<p className="stat-title">Typically Takes</p>
					<p className={`stat-text ${classes.header}`}>10-15 Minutes</p>
				</Col>

				<Col>
					<p className="stat-title">Medical Exam</p>
					<p className={`stat-text ${classes.header}`}>No</p>
				</Col>
			</Row>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Cards/AmericoQuoteCard.js